<template>
	<Modals
		:title="'Create New User'"
		:validateBeforeClose="validateBeforeClose"
		:display="display"
		@show="closeUserSettingModal"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		:fullMobile="true"
	>
		<template #modal-content>
			<div class="user-info__container">
				<UserForm
					@hasError="updateHasErrorModal"
					v-model="dataModal"
					:errorMessage="errorMessage"
					:forceErrorMessage="forceErrorMessage"
					:showNotificationError="showNotificationError"
				/>
			</div>
		</template>
		<template #modal-footer>
			<ButtonGroup
				:items="[
					{
						id: 'saveButtonModal',
						className: 'btn--primary',
						labelText: 'Create',
						type: 'submit',
						disabled: hasError,
						btnClick: saveAction
					},
					{
						id: 'cancelButtonModal',
						className: 'btn--link',
						labelText: 'Cancel',
						btnClick: cancelAction
					}
				]"
			/>
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import UserForm from './user-form.vue';
import ButtonGroup from '@/components/forms/button/button-group';
import _ from 'lodash';
import { mapActions } from 'vuex';

export default {
	name: 'UserAddModal',
	components: {
		Modals,
		UserForm,
		ButtonGroup
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		display: {
			type: Boolean,
			default: false
		},
		validateBeforeClose: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			hasError: true,
			dataModal: {},
			showNotificationError: false,
			forceErrorMessage: '',
			errorMessage: ''
		};
	},
	methods: {
		...mapActions('users', { createUserAction: 'createUser' }),
		closeUserSettingModal(e) {
			if (!this.validateBeforeClose) {
				this.cancelAction(e);
			}
		},
		async saveAction(e) {
			e?.preventDefault();
			const roles = _.union(
				this.dataModal.internalIds,
				this.dataModal.consultantIds
			).map(id => ({ roleId: id }));

			let user = _.omit(this.dataModal, ['internalIds', 'consultantIds']);
			Object.assign(user, { roles });

			await this.createUserAction(user).then(response => {
				const { isSuccessful } = response;

				if (isSuccessful) {
					this.cancelAction();
				}
				if (!isSuccessful) {
					const { statusCode, message } = response;
					if (statusCode === 409) {
						this.forceErrorMessage = message.match(
							/^(.*?\..*?\.)/
						)[0];
					} else {
						this.errorMessage = message;
						this.showNotificationError = true;
					}
				}
			});
		},
		cancelAction(e) {
			if (e) e.preventDefault();
			this.dataModal = {};
			if (this.showNotificationError) {
				this.showNotificationError = false;
			}
			this.$emit('show', false);
		},
		updateHasErrorModal(val) {
			this.hasError = val;
		}
	},
	watch: {
		display: {
			handler(val) {
				if (val) {
					this.dataModal = {
						active: true,
						internalIds: [],
						consultantIds: []
					};
					this.validatePermission('users.create', true);
				}
			}
		},
		'dataModal.email': {
			handler() {
				if (this.forceErrorMessage) {
					this.$nextTick(() => {
						this.forceErrorMessage = '';
					});
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    *
    * Add User
    * Can use SCSS variables = TRUE
    *
 */

/*------------------------------------*\
  #BASE
\*------------------------------------*/
::v-deep .modal {
	&__body {
		overflow: initial; //added to fix role dropdown from being cut-off
	}
}

/*------------------------------------*\
  #BASE TABLET-UP
\*------------------------------------*/
@include mq($from: md) {
	.user-info__container {
		width: 560px;
	}
}
</style>
